<template>
  <div>
    <div class="container-fluid">
      <div class="row mt-3 gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Plataforma</label>
          <p><b>{{ tratarDados('plataforma', arquivoEstruturado.plataformaId) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Tipo de registro</label>
          <p><b>{{ tratarDados('tipoRegistro', arquivoEstruturado.tipo_registro) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Nome do órgão solicitante</label>
          <p><b>{{ arquivoEstruturado.orgao_solicitante || 'Não informado' }}</b></p>
        </div>

        <div v-if="arquivoEstruturado.tipo_registro === 'nascimento'"
             class="col-md-3">
          <label class="text-muted mb-1">CNPJ do órgão solicitante</label>
          <p><b>{{ tratarDados('cnpj', arquivoEstruturado.CNPJ_orgao_solicitante) }}</b></p>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">CPF do solicitante</label>
          <p><b>{{ tratarDados('cpf', arquivoEstruturado.cpf_solicitante) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Nome do solicitante</label>
          <p><b>{{ arquivoEstruturado.nome_solicitante || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">CNS do cartório de origem</label>
          <p><b> {{ (arquivoEstruturado.tipo_registro === 'obito' ? arquivoEstruturado.cartorio_destino_cns : arquivoEstruturado.cartorio_solicitante_cns) || 'Não informado' }}</b></p>
        </div>

        <div v-if="arquivoEstruturado.tipo_registro === 'nascimento'"
             class="col-md-3">
          <label class="text-muted mb-1">CNS do cartório de destino</label>
          <p><b>{{ arquivoEstruturado.cartorio_destino_cns || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IdentificacaoSolicitacao',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não informado'

        switch (tipo) {
        case 'tipoRegistro':
          return this.tratarTipoRegistro(dado)

        case 'plataforma':
          return this.tratarPlataforma(dado)

        case 'cpf':
          return this.formatarCpf(dado)

        case 'cnpj':
          return this.formatarCnpj(dado)

        default:
          return dado
        }
      },
      tratarTipoRegistro (dado) {
        const tipos = {
          nascimento: 'Nascimento',
          obito: 'Óbito'
        }

        return tipos[dado] || dado
      },
      tratarPlataforma (dado) {
        const plataformas = {
          unidade_interligada: 'Unidade Interligada',
          'e-obito': 'e-Óbito'
        }

        return plataformas[dado] || dado
      },
      formatarCpf (cpf) {
        cpf = cpf.toString().replace(/\D/g, '')

        if (cpf.length !== 11) return cpf

        return cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      },
      formatarCnpj (cnpj) {
        cnpj = cnpj.toString().replace(/\D/g, '')

        if (cnpj.length !== 14) return cnpj

        return cnpj.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        )
      }
    }
  }
</script>